import pageWrapper from './PageWrapper';

export default pageWrapper;
